<div class="question-panel">
  <div class="custom-answer__group custom-answer__group--value form-group mb-0" id="ca-example-7">
    @for (item of questions; track item; let index = $index) {
      <div class="custom-answer">
        <div class="custom-answer__title">
          <label>{{item.question_prompt}}</label>
        </div>
        <div class="custom-answer__amount">
          <input currencyMask type="text" placeholder="R 0" class="form-control"
            [(ngModel)]="item.answer" [options]="maskOptions" (ngModelChange)="saveValue()">
          </div>
        </div>
      }
    </div>
    @if (showTotal) {
      <div class="question-panel__total">
        <div class="question-panel__total-name">
          <p>Total</p>
        </div>
        <div class="question-panel__total-amount">
          <p><span>{{totalAmount | currency : 'ZAR' : 'R' : '1.0-0'}}</span></p>
        </div>
      </div>
    }
  </div>

